import { css } from '@emotion/react';
import {
  HEIGHT_MAX,
  WIDTH_MAX,
  WIDTH_NAVIGATION_VIEW
} from '@pages/Main/MainView/constants';

export const bannerContainer = css({
  height: 426
});

export const videoGradiant = css({
  width: WIDTH_MAX,
  height: HEIGHT_MAX,
  objectFit: 'cover',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: -1,
  background:
    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9))'
});

export const contentWrapper = css({
  width: WIDTH_MAX - WIDTH_NAVIGATION_VIEW,
  height: 633,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: 10
});
